import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";

import logger from "../../../../logger";

export const imageKeys = {
  all: ["images"],
  lists: () => [...imageKeys.all, "list"],
  list: (filters) => [...imageKeys.lists(), { filters }],
  items: () => [...imageKeys.all, "item"],
  item: ({ userId, url }) => [...imageKeys.items(), `${userId}#${url}`],
};

export function useCreateImage(func) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: (data, variables) => {
      const { userId } = variables;
      const { Item } = data;
      const { url } = Item;
      queryClient.setQueryData(imageKeys.item({ userId, url }), { url });
      return data;
    },
  });
}

export function useUpdateImage(func) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: (data, variables) => {
      const { userId, imageName } = variables;
      queryClient.setQueryData(imageKeys.item({ userId, imageName }), {
        url: data.item.url,
      });
      queryClient.invalidateQueries({ queryKey: imageKeys.lists() });
    },
  });
}

export function useDeleteImage(func) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables) => func(variables),
    onError: (error) => {
      // An error happened!
      logger.error(error);
    },
    onSuccess: (variables) => {
      const { userId, imageName } = variables;
      queryClient.setQueryData(imageKeys.item({ userId, imageName }), "");
    },
  });
}

export function useImage(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: imageKeys.item({ ...args }),
    queryFn: () => func(),
    ...queryOptions,
  });
}

export function useImages(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: imageKeys.item({ ...args }),
    queryFn: () => func(),
    ...queryOptions,
  });
}

export function useCreateBuffer(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: imageKeys.item({ ...args }),
    queryFn: () => func(),
    ...queryOptions,
  });
}
